import { useBooleanFlag } from '@trm/feature-flags/web';

export const usePayoutDetailsV2Flag = () => ({
  isPayoutDetailsV2Enabled: useBooleanFlag('payout-returns-payout-details-v2', false),
});
